import { render, staticRenderFns } from "./BanquetList.vue?vue&type=template&id=07ab6ea9&scoped=true"
import script from "./BanquetList.vue?vue&type=script&lang=js"
export * from "./BanquetList.vue?vue&type=script&lang=js"
import style0 from "./BanquetList.vue?vue&type=style&index=0&id=07ab6ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab6ea9",
  null
  
)

export default component.exports